import React from "react";

function AboutQuestionTitle({ content }) {
    return <h3 className="about__question">{content}</h3>;
}

export default AboutQuestionTitle;
